import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CrearPost.css";

function CrearPost() {
  const navigate = useNavigate();

  const [titulo, setTitulo] = useState("");
  const [resumen, setResumen] = useState("");
  const [contenido, setContenido] = useState("");
  const [imagen, setImagen] = useState(null);
  const [mensaje, setMensaje] = useState("");

  const crearPost = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("resumen", resumen);
    formData.append("contenido", contenido);
    formData.append("imagen", imagen);

    try {
      const token = localStorage.getItem("token");

      const res = await fetch("/api/posts", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });

      const textoRespuesta = await res.text();

      if (!res.ok) {
        throw new Error(textoRespuesta);
      }

      setMensaje("✅ Post creado correctamente");

      setTimeout(() => {
        navigate("/noticias");
      }, 800);

    } catch (error) {
      console.error(error);
      setMensaje("❌ " + error.message);
    }
  };

  return (
    <div className="crear-post-container">
      <h2>Crear nuevo post</h2>

      <form onSubmit={crearPost} className="crear-post-form">
        <input
          type="text"
          placeholder="Título del post"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Resumen corto"
          value={resumen}
          onChange={(e) => setResumen(e.target.value)}
          required
        />

        <textarea
          placeholder="Contenido completo del post"
          value={contenido}
          onChange={(e) => setContenido(e.target.value)}
          required
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImagen(e.target.files[0])}
          required
        />

        <button type="submit">Crear post</button>
      </form>

      {mensaje && <p style={{ marginTop: "15px" }}>{mensaje}</p>}
    </div>
  );
}

export default CrearPost;